import React, { useState } from "react";
import * as API from "lib/apis";

const SignupTest = () => {
  const [ci, setCi] = useState("");
  const [membershipId, setMembershipId] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [encData, setEncData] = useState("");

  if (process.env.REACT_APP_ENVIRONMENT === "prod") {
    return null;
  }

  const handleSignup = () => {
    if (!ci.trim() || !membershipId.trim()) {
      setMessage("ci와 membershipId를 모두 입력해주세요.");
      return;
    }

    setMessage("");
    setEncData("");
    setIsLoading(true);

    API.signUpHana(ci.trim(), membershipId.trim(), (res) => {
      setIsLoading(false);
      if (!res || !res.success) {
        setMessage(
          res && res.message ? res.message : "가입 요청에 실패했습니다."
        );
        return;
      }
      setEncData(res.data);
      setMessage(
        "가입 요청 성공. 아래 '본인인증 시작' 버튼을 눌러 NICE 본인인증을 진행하세요."
      );
    });
  };

  const fnPopup = () => {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }

    document.form_chk.action =
      "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
    document.form_chk.target = "_self";
    document.form_chk.submit();
  };

  return (
    <div style={{ padding: 20 }}>
      <h3>회원가입 테스트 (개발용, 하나머니)</h3>
      <p style={{ color: "#888" }}>
        prod가 아닌 환경에서만 동작합니다. 버튼을 눌러야만 API가 호출됩니다.
      </p>

      <p>
        <label>
          ci&nbsp;
          <input
            type="text"
            value={ci}
            onChange={(e) => setCi(e.target.value)}
            placeholder="가입할 사용자의 ci 값을 붙여넣으세요"
            style={{ width: 400 }}
          />
        </label>
      </p>

      <p>
        <label>
          membershipId&nbsp;
          <input
            type="text"
            value={membershipId}
            onChange={(e) => setMembershipId(e.target.value)}
            placeholder="테스트 membershipId"
            style={{ width: 400 }}
          />
        </label>
      </p>

      {message && <p>{message}</p>}

      <button onClick={handleSignup} disabled={isLoading}>
        {isLoading ? "가입 중..." : "가입하기"}
      </button>

      {encData && (
        <>
          &nbsp;
          <button onClick={fnPopup}>본인인증 시작</button>
        </>
      )}

      <form name="form_chk" method="post" style={{ visibility: "hidden" }}>
        <input type="text" readOnly name="m" value="checkplusService" />
        <input type="text" readOnly name="EncodeData" value={encData} />
        <input type="text" readOnly name="param_r1" value={membershipId} />
        <input type="text" readOnly name="param_r2" value="" />
        <input type="text" readOnly name="param_r3" value="DATA3" />
      </form>
    </div>
  );
};

export default SignupTest;
